import AnimatedHearts from '@/components/animated-hearts';
import { useI18n } from '@/lib/i18n';
import { ChatBubbleOvalLeftIcon, EllipsisHorizontalIcon, HeartIcon } from '@heroicons/react/24/outline';
import Logo from '@images/Logo.svg';
import PostSittingTable from '@images/Post-Sitting-Table.webp';
import PostTurquoise from '@images/Post-Turquoise.webp';
import PostYellowWall from '@images/Post-Yellow-Wall.webp';
import { memo, useEffect, useState } from 'react';

export default function SocialMediaCards() {
  return (
    <>
      <SocialMediaCard src={PostTurquoise} className={'relative z-10'} />
      <SocialMediaCard src={PostYellowWall} className={'absolute top-0 left-0 z-0 -translate-x-2/5 scale-75 -rotate-6'} />
      <SocialMediaCard src={PostSittingTable} className={'absolute top-0 left-0 z-0 translate-x-2/5 scale-75 rotate-6'} />
    </>
  );
}

function SocialMediaCard({ src, className }: { src: string; className?: string }) {
  const { t } = useI18n();

  return (
    <div className={`overflow-hidden rounded-2xl bg-white shadow-2xl ${className}`}>
      <div className={'flex items-center gap-1.5 bg-white p-3'}>
        <div className={'bg-secondary rounded-full p-1.5'}>
          <img className={'size-6'} src={Logo} alt="Influencer" />
        </div>
        <div className={'flex-1'}>
          <div className={'text-sm font-semibold'}>boostbuddy</div>
          <div className={'text-xs text-gray-700'}>{t('layout.City, Country')}</div>
        </div>
        <EllipsisHorizontalIcon className={'size-6'} />
      </div>

      <div className="relative">
        <img className={'aspect-square w-full object-cover'} src={src} alt="Post" />
        <AnimatedHearts />
      </div>

      <div className={'flex items-center gap-1.5 bg-white p-3'}>
        <HeartIcon className={'size-6'} />
        <div className={'w-12 overflow-hidden text-sm font-semibold'}>
          <AmountOfLikes start={100} />
        </div>
        <ChatBubbleOvalLeftIcon className={'size-6'} />
        <div className={'w-12 overflow-hidden text-sm font-semibold'}>
          <AmountOfLikes start={30} />
        </div>
      </div>
    </div>
  );
}

const AmountOfLikes = memo(({ start }: { start: number }) => {
  const [likes, setLikes] = useState(start);

  useEffect(() => {
    const interval = setInterval(() => {
      setLikes((prev) => prev + Math.round((Math.random() * start) / 10));
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return likes;
});
